import { SolidButton } from "@components/atoms/base-button";
import { CloseIcon } from "@components/atoms/Icons/index";
import { ReactNode, useMemo, useReducer } from "react";
import { translate } from "@locales";
import { FIlterIcon } from "@components/atoms/Icons/components/filter-icon";

function useResponsiveSidebar() {
  const [showFilter, toggleShowFilter] = useReducer((value) => !value, false);

  const hiddenClass = useMemo(() => (showFilter ? "" : "hidden"), [showFilter]);

  return {
    models: {
      hiddenClass,
    },
    operations: {
      toggleShowFilter,
    },
  };
}

interface ResponsiveSidebarProps {
  sidebar: ReactNode;
}

export function ResponsiveSidebar({ sidebar }: ResponsiveSidebarProps) {
  const { models, operations } = useResponsiveSidebar();
  const { toggleShowFilter } = operations;
  const { hiddenClass } = models;

  return (
    <>
      <button
        onClick={toggleShowFilter}
        className="border border-black border-solid h-9 w-9 flex justify-center items-center"
      >
        <FIlterIcon width="14px" height="14px" />
      </button>
      <div
        className={`z-50 fixed top-0 left-0 h-screen w-screen grid grid-rows-[65px_1fr_80px] ${hiddenClass}`}
      >
        <div className="flex items-center justify-between bg-[#F8F8F8] h-[65px] w-full px-5">
          <span className="font-chivo-bold text-[28px] italic uppercase">
            {translate("shop.filter.filter-by")}
          </span>
          <button onClick={toggleShowFilter}>
            <CloseIcon width="16px" height="16px" />
          </button>
        </div>
        <div className="overflow-auto bg-white px-11 pb-[279px]">{sidebar}</div>
        <div className="flex items-center justify-center bg-white h-20 w-full">
          <SolidButton onClick={toggleShowFilter} className="w-wide178">
            {translate("shop.filter.show-results")}
          </SolidButton>
        </div>
      </div>
    </>
  );
}
